var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full mt-6 leading-5 bg-gray-400 rounded-full"},_vm._l((_vm.tags),function(tag,index){return _c('button',{key:index,staticClass:"flex inline-flex items-center justify-center w-full px-2 py-2 text-base font-medium leading-5 bg-gray-400 rounded-full focus:outline-none",class:{
            'text-gray-700  ': !tag.isActive,
            'bg-blue-600 outline-none text-white ': tag.isActive
        },on:{"click":function($event){return _vm.clicked(tag)}}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }